import React, { useEffect, useState } from "react";
import performRequest from "../../../api/request";
import CustomInput from "../../../CustomComponent/custom_input";
import { Form, Formik } from "formik";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { hardvestCreateInfo } from "../../../SchemaInfo/info";
import { HarvestcreateSchema } from "../../../Schemas/Farm support/harvest_manegment_schema";
import StepRoutes from "../../../Routes/steps_routes";
import { PiPlantLight } from "react-icons/pi";
import { Toast } from "../../../CustomComponent/toast";
import { useNavigate, useParams } from "react-router";
import LoadingPage from "../../../Components/layouts/loading";
import CustomSelect from "../../../CustomComponent/custom_select";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

function Edit_harvest() {
  const [plantList, setPlantList] = useState([]);
  const [harvestInfo, setHarvestInfo] = useState(hardvestCreateInfo);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [isHandOverCompleted, setIsHandOverCompleted] = useState(false);

  useEffect(() => {
    performRequest("GET", "/handOver/getHandOver/")
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.handOverData?.length > 0) {
            setIsHandOverCompleted(true);
          } else {
            setIsHandOverCompleted(false);
          }
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  }, []);
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/harvest/getHarvestById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setHarvestInfo(res.data);
        } else {
          Toast("error", "Error while getting harvest info!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    performRequest("GET", "/agronomyWiki/getAllAgronomyWiki/")
      .then((res) => {
        if (res.status === 200) {
          setPlantList(res.data?.data || []);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  }, []);

  const handelSubmit = (values) => {
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    performRequest("PATCH", `/harvest/updateHarvest/${id}`, formData, headers)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Harvest updated successfully!");
          navigate(`/farm-harvest-management/`);
        } else {
          Toast("error", "Error while creating harvest!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      });
  };

  if (loading) {
    return <LoadingPage />;
  }

  const today = new Date().toISOString().split("T")[0];

  if (!isHandOverCompleted) {
    navigate("/farm-harvest-management/");
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <PiPlantLight
                    className="fs-2 me-1"
                    style={{ color: "green" }}
                  />
                  Harvest Management
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit Harvest Management</h2>
            </div>
            <Formik
              initialValues={{ ...harvestInfo, harvestDate: today }}
              validationSchema={HarvestcreateSchema}
              onSubmit={handelSubmit}
              enableReinitialize
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 col-lg-12 col-md-12">
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Harvest Date
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="harvestDate"
                              type="text"
                              value={today}
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Crop Name
                          </label>
                          <div className="w-100 col">
                            <CustomSelect type="text" name="selectCrop">
                              <option value="">Select</option>
                              {plantList.map((plant) => (
                                <option key={plant.id} value={plant.name}>
                                  {plant.name}
                                </option>
                              ))}
                            </CustomSelect>
                            {props.touched.selectCrop &&
                              props.errors.selectCrop && (
                                <p className="text-danger">
                                  {props.errors.selectCrop}
                                </p>
                              )}
                          </div>
                        </div>
                        {harvestInfo?.uploadProductPhoto && (
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              Uploaded product photo
                            </label>
                            <div className="w-100 col">
                              <LazyImageComponent
                                height={"150px"}
                                src={harvestInfo?.uploadProductPhoto}
                                alt={harvestInfo?.uploadProductPhoto}
                              />
                            </div>
                          </div>
                        )}
                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3">
                            Upload product photo
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="uploadProductPhoto"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "uploadProductPhoto",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.uploadProductPhoto &&
                              props.errors.uploadProductPhoto && (
                                <p className="text-danger">
                                  {props.errors.uploadProductPhoto}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Harvest Quantity (Kg)
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="harvestQuantity" type="text" />
                            {props.touched.harvestQuantity &&
                              props.errors.harvestQuantity && (
                                <p className="text-danger">
                                  {props.errors.harvestQuantity}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Transportation option
                          </label>
                          <div className="w-100 col">
                            <CustomSelect name="transportation" type="text">
                              <option value=" ">Select</option>
                              <option value="towards buyer">
                                Toward's Buyer
                              </option>
                              <option value="towards farmer">
                                Toward's Farmer
                              </option>
                            </CustomSelect>
                            {props.touched.transportation &&
                              props.errors.transportation && (
                                <p className="text-danger">
                                  {props.errors.transportation}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Packaging Type
                          </label>
                          <div className="w-100 col">
                            <CustomSelect name="packagingType" type="text">
                              <option value="">Select</option>
                              <option value="loose">Loose</option>
                              <option value="gunny bag">Gunny Bag</option>
                              <option value="carton">Carton</option>
                              <option value="individual piece">
                                Individual Piece
                              </option>
                            </CustomSelect>
                            {props.touched.packagingType &&
                              props.errors.packagingType && (
                                <p className="text-danger">
                                  {props.errors.packagingType}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Selling Price/Kg
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="sellingPricePerKg" type="text" />
                            {props.touched.sellingPricePerKg &&
                              props.errors.sellingPricePerKg && (
                                <p className="text-danger">
                                  {props.errors.sellingPricePerKg}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Total Price
                          </label>
                          <div className="w-100 col">
                            ₹
                            {props.values.harvestQuantity *
                              props.values.sellingPricePerKg}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Save Harvest" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Edit_harvest;
